import { CustomerCompanyMessage } from '../../../../../types/CustomerCompanyMessage';
import { CompanyTabs } from '../../../common/CompanyTabs';

import { CustomerCommunicationPreferencesTab } from './CustomerCommunicationPreferencesTab';
import { CustomerDetailsTab } from './CustomerDetailsTab';
import { CustomerSettingsTab } from './CustomerSettingsTab';

interface CustomerDetailsPageTabContentProps {
    tab: CompanyTabs;
    customer: CustomerCompanyMessage;
}

export const CustomerDetailsPageTabContent = ({ tab, customer }: CustomerDetailsPageTabContentProps) => {
    switch (tab) {
        case CompanyTabs.DETAILS:
            return <CustomerDetailsTab customer={customer} />;
        case CompanyTabs.SETTINGS:
            return <CustomerSettingsTab customer={customer} />;
        case CompanyTabs.COMMUNICATION_PREFERENCES:
            return <CustomerCommunicationPreferencesTab companyId={customer.id} />;
        default:
            return null;
    }
};
